import AxiosConfig from "./AxiosConfig";
import img from "../assets/images/logo192.png";
import modalError from "../components/Modal/ModalError";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck, faFileImport, faRemove} from "@fortawesome/free-solid-svg-icons";
import { ReactComponent as SablierIcone } from "../icons/asu_file_dattente.svg";
import { ReactComponent as AnnulerIcone } from "../icons/annuler.svg";

const saveSeanceToLocal = (newValue, userId, rateTargetId) => {
    return new Promise((resolve, reject) => {
        if (typeof newValue !== 'number' || typeof userId !== 'number' || typeof rateTargetId !== 'number' || isNaN(newValue) || isNaN(userId) || isNaN(rateTargetId)) {
            console.error('Les paramètres {newValue, userId, rateTargetId} doivent être de type int.');
            return reject(new Error('Les paramètres {newValue, userId, rateTargetId} doivent être de type int.'));
        }

        const dataToStore = {
            value: newValue,
            user: userId,
            rateTarget: rateTargetId,
        };
        const ratingsData = JSON.parse(localStorage.getItem('ratingsData')) || [];
        const existingIndex = ratingsData.findIndex(rating =>
            rating.user === userId && rating.rateTarget === rateTargetId
        );
        if (existingIndex > -1) {
            ratingsData.splice(existingIndex, 1);
        }
        ratingsData.push(dataToStore);
        localStorage.setItem('ratingsData', JSON.stringify(ratingsData));
        resolve(dataToStore);
    });
};

const registerUserToSeanceAPI = async (seanceId) => {
    const response = await AxiosConfig.post(`/activite_seance_users/add_user_to_seance/${seanceId}`, );
    return response.data;
};

const unregisterUserToSeanceAPI = async (seanceId) => {
    const response = await AxiosConfig.post(`/activite_seance_users/remove_user_to_seance/${seanceId}`, );
    return response.data;
};

const registerUserToSeanceByCoachAPI = async (seanceId, values) => {
    const response = await AxiosConfig.post(`/activite_seance_users/add_user_to_seance_by_coach/${seanceId}`, values );
    return response.data;
};

const unregisterUserToSeanceByCoachAPI = async (seanceId, values) => {
    const response = await AxiosConfig.post(`/activite_seance_users/add_user_to_seance_by_coach/${seanceId}`, values );
    return response.data;
};

const getSeanceLocal = (id) => {
    return new Promise((resolve, reject) => {

        const storedData = JSON.parse(localStorage.getItem('seancesData'));
        if (storedData) {
            const foundSeance = storedData.find(s => s.id === +id);
            resolve(foundSeance);
        }
    });
};

const getSeanceApi = async (id) => {
    try {
        const response = await AxiosConfig.get(`/seances/seance/${id}`);
        return response.data;
    } catch (error) {
        console.error("error", error);
        if (error.response) {
            if (error.response.status === 403) {
                console.error('Accès refusé. Vous n\'avez pas la permission d\'accéder à cette ressource.');
                return { success: false, message: 'Accès refusé. Vous n\'avez pas la permission d\'accéder à cette ressource.' };
            } else {
                console.error('Une erreur est survenue lors de la récupération des données.');
                return { success: false, message: 'Une erreur est survenue lors de la récupération des données.' };
            }
        } else if (error.request) {
            console.error('No response received:', error.request);
            return { success: false, message: 'Le serveur ne répond pas.' };
        } else {
            console.error('Error:', error.message);
            return { success: false, message: 'Une erreur est survenue : '+error.message };
        }

        throw error;
    }
};

const getSeancesLocal = async (userId, endpoint) => {
    return new Promise((resolve, reject) => {
        const storedData = localStorage.getItem('seancesData');
        if (storedData) {
            resolve(JSON.parse(storedData));
        }
    });
};

const getSeancesApi = async (userId, endpoint) => {
    try {
        const response = await AxiosConfig.get(`/seances/${endpoint}`);
        if (!response.ok) {
            throw new Error('Network response was not ok.');
        }
        const data = await response.json();
        return data;
    } catch (error) {
        throw error;
    }
};

const getAccueilLocal = async (userId, endpoint) => {
    const cardsData = [
        {
            id: 1,
            lien: "/seances/enregistrees?sort=date",
            image: img,
            titre: "MES SÉANCES À VENIR",
        },
        {
            id: 2,
            lien: "/seances/disponibles?sort=date",
            image: img,
            titre: "PLANNING DES SÉANCES",
        },
        {
            id: 3,
            lien: "/activites/myCompany",
            image: img,
            titre: "ACTIVITÉS DISPONIBLES",
        },
        {
            id: 4,
            lien: "/seances/effectuees?sort=dateDesc",
            image: img,
            titre: "MON HISTORIQUE DE SÉANCES",
        }
    ];

    return new Promise((resolve, reject) => {
        const storedData = localStorage.getItem('seancesData');
        if (storedData) {
            resolve({ seances: JSON.parse(storedData), cardsData: cardsData });
        }
    });
}

const getAccueilApi = async (endpoint) => {
    try {
        const response = await AxiosConfig.get(`/accueil`);
        return response.data;
    } catch (error) {
        console.error('error: ', error);
        throw error;
    }
};

const getSeancesByActiviteLocal = async (userId) => {
    return new Promise((resolve, reject) => {
        const storedData = localStorage.getItem('seancesData');
        if (storedData) {
            resolve(JSON.parse(storedData));
        }
    });
}

const getSeancesByActiviteApi = async (userId) => {

}

const getTypesActivites = async () => {
    try {
        const response = await AxiosConfig.get(`/activites/types`);
        return response.data;
    } catch (error) {
        console.error('error: ', error);
        throw error;
    }
}

const setSeanceShowLast = async (id) => {
    try {
        const response = await AxiosConfig.post(`/activite_seance_users/disableShowRatingModal/${id}`);
        return response.data;
    } catch (error) {
        console.error('error: ', error);
        throw error;
    }
}

const addUserToSeanceAPI = async (seanceId, email) => {

}

const SEANCE_STATUS = {
    actif: { value: 1, label: 'Actif' },
    valide: { value: 2, label: 'Validé' },
    annule: { value: 3, label: 'Annulé' },
};

const parseSeanceStatus = (status) => {
    switch (status) {
        case SEANCE_STATUS.actif.value:
            return SEANCE_STATUS.actif.label;
        case SEANCE_STATUS.valide.value:
            return SEANCE_STATUS.valide.label;
        case SEANCE_STATUS.annule.value:
            return SEANCE_STATUS.annule.label;
        default:
            return 'Statut inconnu';
    }
}

const getSeanceStatusIcon = (status) => {
    switch (status) {
        case SEANCE_STATUS.actif.value:
            return <FontAwesomeIcon icon={faFileImport} style={{ color: "var(--clr-warning)" }} />;
        case SEANCE_STATUS.valide.value:
            return <FontAwesomeIcon icon={faCheck} style={{ color: "var(--clr-success)"}} />;
        case SEANCE_STATUS.annule.value:
            return <FontAwesomeIcon icon={faRemove} style={{ color: "var(--clr-danger)" }} />;
        default:
            return <FontAwesomeIcon icon={faRemove} style={{ color: "var(--clr-danger)" }} />;
    }
}

const PARTICIPATION_STATUS = {
    file_attente_non_prio: { value: -2, label: 'File d\'attente non prioritaire' },
    pas_enregistre: { value: -1, label: 'Pas enregistré' },
    file_attente: { value: 0, label: 'File d\'attente' },
    valide: { value: 1, label: 'Validé' },
    annule_utilisateur: { value: 2, label: 'Annulé par l\'utilisateur' },
    refuse: { value: 3, label: 'Refusé' },
};

const parseParticipationStatus = (status) => {
    const statusObj = Object.values(PARTICIPATION_STATUS).find(item => item.value === status);
    return statusObj ? statusObj.label : 'Statut inconnu';
}

const getParticipationStatusIcon = (status) => {
    switch (status) {
        case PARTICIPATION_STATUS.pas_enregistre.value:
            return <AnnulerIcone style={{ fill: "var(--clr-danger)"}} />// <FontAwesomeIcon icon={faFileImport} style={{ color: "var(--clr-danger)" }} />;
        case PARTICIPATION_STATUS.file_attente.value:
        case PARTICIPATION_STATUS.file_attente_non_prio.value:
            return <SablierIcone style={{ fill: "var(--clr-warning)", maxWidth: "24px"}} />;
        case PARTICIPATION_STATUS.valide.value:
            return <FontAwesomeIcon icon={faCheck} style={{ color: "var(--clr-success)"}} />;
        case PARTICIPATION_STATUS.annule_utilisateur.value:
            return <FontAwesomeIcon icon={faRemove} style={{ color: "var(--clr-danger)" }} />;
        case PARTICIPATION_STATUS.refuse.value:
            return <FontAwesomeIcon icon={faRemove} style={{ color: "var(--clr-danger)" }} />;
        default:
            return <FontAwesomeIcon icon={faRemove} style={{ color: "var(--clr-danger)" }} />;
    }
}

const getRatingColor = (seance) => {
    if (seance.rate === null) {
        return "#cbcdd2";
    } else {
        return "#f1c40f";
    }
}

const afficherRating = (seance) => {
    if (!seance) return false;
    return new Date(seance.startDate) < new Date() && seance.userPresence === true && seance.status === 2;
}

const afficherRegisterFileAttenteButton = (seance) => {
    if (!seance) return false;

    return seance.registerInQueue === true;

    return new Date(seance.startDate) > new Date()
        && seance.userRegistered === false
        && seance.status === SEANCE_STATUS.actif.value
        && seance.placesRestantes < 1
        ;
}

const afficherRegisterButton = (seance) => {
    if (!seance) return false;

    return new Date(seance.startDate) > new Date() && seance.userRegistered === false && seance.status === SEANCE_STATUS.actif.value;
}

const afficherUnregisterButton = (seance) => {
    if (!seance) return false;
    return new Date(seance.startDate) > new Date() && seance.userRegistered === true && seance.status === SEANCE_STATUS.actif.value;
}

const afficherUnregisterFileAttenteButton = (seance) => {
    if (!seance) return false;
    return new Date(seance.startDate) > new Date()
        && seance.userRegistered === true
        && (seance.asu_status === PARTICIPATION_STATUS.file_attente
            || seance.asu_status === PARTICIPATION_STATUS.file_attente_non_prio)
        && seance.status === SEANCE_STATUS.actif.value;
}

export {
    PARTICIPATION_STATUS,
    SEANCE_STATUS,
    saveSeanceToLocal,
    getSeanceLocal,
    getSeanceApi,
    getSeancesLocal,
    getSeancesApi,
    getSeancesByActiviteLocal,
    getSeancesByActiviteApi,
    getAccueilApi,
    getAccueilLocal,
    getTypesActivites,
    registerUserToSeanceAPI,
    unregisterUserToSeanceAPI,
    setSeanceShowLast,
    registerUserToSeanceByCoachAPI,
    unregisterUserToSeanceByCoachAPI,
    parseSeanceStatus,
    getSeanceStatusIcon,
    parseParticipationStatus,
    getParticipationStatusIcon,
    getRatingColor,
    afficherRating,
    afficherRegisterButton,
    afficherUnregisterButton,
    afficherRegisterFileAttenteButton,
    afficherUnregisterFileAttenteButton,
};
